export default __webpack_public_path__ + "static/media/bg-pubg-2.412b1a82.png";